module.exports = __webpack_public_path__ + "static/media/ru.b72ab197.mp4";